export class PraRemarksItemsModels {
  createdAt?: string;
  isPublic?: boolean;
  proposedEdit?: string;
  proposedOriginal?: string;
  regActRemarkId?: string;
  regActRemarkItemId?: string;
  remarkReference?: string;
  responseComment?: string;
  updatedAt?: string;
  responseType: string;

  constructor(items: any) {
    this.createdAt = items.createdAt;
    this.isPublic = items.isPublic;
    this.proposedEdit = items.proposedEdit;
    this.proposedOriginal = items.proposedOriginal;
    this.regActRemarkId = items.regActRemarkId;
    this.regActRemarkItemId = items.regActRemarkItemId;
    this.remarkReference = items.remarkReference;
    this.responseComment = items.responseComment;
    this.updatedAt = items.updatedAt;
    this.responseType = items.responseType;
  }
}
